export enum ReflectionPupilTypeEnum {
  Father = 'father',
  Mother = 'mother',
  Other = 'other',
}
